import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token');
  const storedCompanyId = sessionStorage.getItem('company_id');

  if (to.name !== 'login') {
    if (!token) {
      next({ name: 'login' });
      return;
    }
    
    // 验证当前 URL 中的 company_id 是否与登录时的 company_id 一致
    // 假设 URL 结构为 /:company_id/#/
    if (storedCompanyId) {
       const pathParts = window.location.pathname.split('/');
       // 查找路径中的数字部分作为 company_id
       const urlCompanyId = pathParts.find(p => p && !isNaN(p) && p.length < 10);
       
       // 如果 URL 中有 company_id 且与存储的不一致，则视为非法跳转，强制登出
       if (urlCompanyId && urlCompanyId != storedCompanyId) {
          sessionStorage.clear();
          next({ name: 'login' });
          return;
       }
    }
  }
  
  if (to.name !== 'login' && !token) {
     next({ name: 'login' });
  } else {
     next();
  }
});

export default router
